export class ToastrTestConfig {
  static toastrConfig = {
    success: () => {},
    error: () => {},
    clear: () => {},
    info: () => {},
    warning: () => {},
  };
}
